module.exports = __webpack_public_path__ + "img/img51.b86c6e88.jpg";